const Injuries = (() => {
  // Grid elements
  var causeTable;
  var locationTable;
  var riskTable;
  var typeTable;
  var pageLoadPopup;

  // The three simple lookups share one shape (single description field).
  const LOOKUPS = {
    cause: { type: 'cause', label: 'Cause', heading: 'Injury Causes', column: 'Cause', addText: 'add new injury cause' },
    risk: { type: 'risk', label: 'Risk', heading: 'Injury Risks', column: 'Risk', addText: 'add new injury risk' },
    type: { type: 'type', label: 'Type', heading: 'Injury Types', column: 'Type', addText: 'add new injury type' },
  };

  // Body-part checkboxes for the Injury Location popup.
  // pct: [x%, y%] — position as percentage of the body diagram wrapper (viewBox 0 0 200 340).
  // anterior right/left = patient's right/left; in the anterior (front) view patient's right
  // appears on the viewer's left, so ar_* sit at low x% and al_* at high x%.
  // In the posterior (back) view the mapping flips: pl_* sit at low x%, pr_* at high x%.
  const BODY = {
    anterior: {
      right: [
        { col: 'ar_shoulder', label: 'Shoulder', pct: [39, 24] },
        { col: 'ar_arm', label: 'Arm', pct: [38, 33] },
        { col: 'ar_hand', label: 'Hand', pct: [34, 51] },
        { col: 'ar_RightLable', label: 'Right', pct: [25, 51] },
        { col: 'ar_upper_leg', label: 'Upper Leg', pct: [40, 60] },
        { col: 'ar_leg', label: 'Leg', pct: [40, 75] },
        { col: 'ar_foot', label: 'Foot', pct: [41, 91] },
      ],
      center: [
        { col: 'a_head', label: 'Head', pct: [50, 8] },
        { col: 'a_neck', label: 'Neck', pct: [50, 24] },
        { col: 'a_chest', label: 'Chest', pct: [50, 31] },
        { col: 'a_pelvic', label: 'Pelvic', pct: [50, 50] },
      ],
      left: [
        { col: 'al_shoulder', label: 'Shoulder', pct: [61, 24] },
        { col: 'al_arm', label: 'Arm', pct: [62, 33] },
        { col: 'al_hand', label: 'Hand', pct: [65, 51] },
        { col: 'al_LeftLable', label: 'Left', pct: [74, 51] },
        { col: 'al_upper_leg', label: 'Upper Leg', pct: [59, 60] },
        { col: 'al_leg', label: 'Leg', pct: [60, 75] },
        { col: 'al_foot', label: 'Foot', pct: [58, 91] },
      ],
    },
    posterior: {
      left: [
        { col: 'pl_shoulder', label: 'Shoulder', pct: [39, 24] },
        { col: 'pl_arm', label: 'Arm', pct: [38, 33] },
        { col: 'pl_hand', label: 'Hand', pct: [34, 50] },
        { col: 'pl_LeftLable', label: 'Left', pct: [25, 50] },
        { col: 'pl_upper_leg', label: 'Upper Leg', pct: [40, 60] },
        { col: 'pl_leg', label: 'Leg', pct: [40, 75] },
        { col: 'pl_foot', label: 'Foot', pct: [41, 91] },
      ],
      center: [
        { col: 'p_head', label: 'Head', pct: [50, 7] },
        { col: 'p_neck', label: 'Neck', pct: [50, 22] },
        { col: 'p_back', label: 'Back', pct: [50, 32] },
        { col: 'p_pelvic', label: 'Pelvic', pct: [50, 49] },
      ],
      right: [
        { col: 'pr_shoulder', label: 'Shoulder', pct: [61, 24] },
        { col: 'pr_arm', label: 'Arm', pct: [62, 33] },
        { col: 'pr_hand', label: 'Hand', pct: [65, 50] },
        { col: 'pr_RightLable', label: 'Right', pct: [74, 50] },
        { col: 'pr_upper_leg', label: 'Upper Leg', pct: [59, 60] },
        { col: 'pr_leg', label: 'Leg', pct: [60, 75] },
        { col: 'pr_foot', label: 'Foot', pct: [58, 91] },
      ],
    },
  };

  function allBodyColumns() {
    const cols = [];
    ['anterior', 'posterior'].forEach(view => {
      ['left', 'center', 'right'].forEach(side => {
        (BODY[view][side] || []).forEach(part => cols.push(part.col));
      });
    });
    return cols;
  }

  // ---------- shared popups ----------
  function showProgressPopup(message) {
    pageLoadPopup = POPUP.build({ hideX: true });
    pageLoadPopup.style.minHeight = '40%';
    const spinner = PROGRESS.SPINNER.get(message);
    spinner.style.display = 'block';
    pageLoadPopup.appendChild(spinner);
    POPUP.show(pageLoadPopup);
  }
  function hideProgressPopup() {
    if (pageLoadPopup) POPUP.hide(pageLoadPopup);
  }

  function showMessagePopup(msg, isExist = false) {
    const popup = POPUP.build({ hideX: true });
    popup.classList.add('warning');
    const message = document.createElement('p');
    message.innerHTML = msg;
    message.style.marginBottom = '15px';
    const btnWrap = document.createElement('div');
    btnWrap.classList.add('btnWrap');
    const okBtn = button.build({
      text: 'Ok', type: 'contained', style: 'secondary',
      callback: () => {
        POPUP.hide(popup);
        if (isExist) {
          const overlay = document.querySelector('.overlay');
          overlay.classList.add('visible'); 
        }
      },
    
    });
    btnWrap.appendChild(okBtn);
    popup.appendChild(message);
    popup.appendChild(btnWrap);
    POPUP.show(popup);
    const closeBtn = popup.querySelector('.closePopupBtn');
    if (closeBtn) closeBtn.remove();
  }

  function showDeleteConfirm(msg, onYes) {
    const popup = POPUP.build({ hideX: true });
    const message = document.createElement('p');
    message.innerHTML = msg;
    const btnWrap = document.createElement('div');
    btnWrap.classList.add('btnWrap');
    btnWrap.style.marginTop = '25px';
    const yesBtn = button.build({
      text: 'Yes', type: 'contained', style: 'secondary',
      callback: async () => { POPUP.hide(popup); await onYes(); },
    });
    const noBtn = button.build({
      text: 'No', type: 'contained', style: 'secondary',
      callback: () => POPUP.hide(popup),
    });
    btnWrap.appendChild(yesBtn);
    btnWrap.appendChild(noBtn);
    popup.appendChild(message);
    popup.appendChild(btnWrap);
    POPUP.show(popup);
  }

  // ---------- simple lookups (cause / risk / type) ----------
  async function populateLookupTable(cfg, tableEle) {
    const result = await _UTIL.fetchData('getInjuryLookups', { token: $.session.Token, type: cfg.type });
    const list = result.getInjuryLookupsResult || [];
    const tableData = list.map(item => ({
      id: item.id,
      values: [item.description],
      endIcon: $.session.SetupDelete === true ? icons['delete'] : icons['empty'],
      endIconCallback: e => {
        e.stopPropagation();
        if ($.session.SetupDelete === true) handleLookupDelete(cfg, item, tableEle);
      },
      onClick: e => {
        if (!e.target.classList.contains('endIcon')) showLookupPopup(cfg, item, tableEle);
      },
    }));
    table.populate(tableEle, tableData);
    table.sortTableByHeader(tableEle);
  }

  function handleLookupDelete(cfg, item, tableEle) {
    const noun = cfg.label.toLowerCase();
    if (item.referenced === 'Y') {
      showMessagePopup(`This injury ${noun} cannot be deleted, because it is associated to an existing injury.`);
      return;
    }
    showDeleteConfirm(`Are you sure you want to delete this injury ${noun}?`, async () => {
      showProgressPopup('Deleting...');
      let res;
      try {
        const r = await _UTIL.fetchData('deleteInjuryLookup', { token: $.session.Token, type: cfg.type, id: item.id });
        res = r.deleteInjuryLookupResult;
      } catch { res = 'exception'; }
      hideProgressPopup();
      if (res === 'success') {
        successfulSave.show('Deleted');
        await populateLookupTable(cfg, tableEle);
        setTimeout(() => successfulSave.hide(), 2000);
      } else if (res === 'referenced') {
        showMessagePopup(`This injury ${noun} cannot be deleted, because it is associated to an existing injury.`);
      } else {
        failSave.show('An error occured.');
        setTimeout(() => failSave.hide(), 2000);
      }
    });
  }

  function showLookupPopup(cfg, item, tableEle) {
    const isEdit = !!item;
    const original = isEdit ? (item.description || '') : '';

    const input = new Input({ label: cfg.label, type: 'text', id: 'injuryLookupValue', maxlength: 100, value: original, required: true });

    const popup = POPUP.build({ classNames: 'injuryPopup', hideX: true });
    const container = document.createElement('div');
    container.appendChild(input.rootElement);

    const btnWrap = document.createElement('div');
    btnWrap.classList.add('btnWrap');
    const saveBtn = button.build({
      id: 'injuryLookupSaveBtn', text: ' Save', icon: ['save'], style: 'secondary', type: 'contained',
      callback: async () => {
        const value = document.getElementById('injuryLookupValue').value.trim();
        saveBtn.classList.add('disabled'); saveBtn.disabled = true;
        showProgressPopup('Saving...');
        let res;
        try {
          const r = await _UTIL.fetchData('saveInjuryLookup', {
            token: $.session.Token, type: cfg.type,
            lookup: { isEdit: isEdit ? 'Y' : 'N', id: isEdit ? String(item.id) : '', description: value },
          });
          res = r.saveInjuryLookupResult;
        } catch { res = 'exception'; }
        hideProgressPopup();
        if (res === 'success') {
          POPUP.hide(popup);
          successfulSave.show('Saved');
          await populateLookupTable(cfg, tableEle);
          setTimeout(() => successfulSave.hide(), 2000);
        } else if (res === 'duplicate') {
          showMessagePopup(`This injury ${cfg.label.toLowerCase()} already exists.`,true);
          toggleLookupSave(cfg, original, isEdit);
        } else {
          failSave.show(res === 'Error:606' || res === 'Error:607'
            ? 'Your session has expired. Please log in and try again.' : 'An error occured.');
          setTimeout(() => failSave.hide(), 2000);
          toggleLookupSave(cfg, original, isEdit);
        }
      },
    });
    const cancelBtn = button.build({
      id: 'injuryLookupCancelBtn', text: 'Cancel', style: 'secondary', type: 'outlined',
      callback: () => POPUP.hide(popup),
    });
    btnWrap.appendChild(saveBtn);
    btnWrap.appendChild(cancelBtn);
    container.appendChild(btnWrap);
    popup.appendChild(container);
    POPUP.show(popup);

    const canEdit = isEdit ? $.session.SetupUpdate : $.session.SetupInsert;
    const inputEle = input.input || document.getElementById('injuryLookupValue');
    if (!canEdit) {
      inputEle.disabled = true;
      inputEle.classList.add('disabled');
    } else {
      inputEle.addEventListener('input', () => toggleLookupSave(cfg, original, isEdit));
    }
    toggleLookupSave(cfg, original, isEdit);
  }

  function toggleLookupSave(cfg, original, isEdit) {
    const inputEle = document.getElementById('injuryLookupValue');
    const saveBtn = document.getElementById('injuryLookupSaveBtn');
    if (!inputEle || !saveBtn) return;
    const value = inputEle.value.trim();
    const permitted = isEdit ? $.session.SetupUpdate : $.session.SetupInsert;
    const changed = value !== original.trim();
    if (value && changed && permitted) {
      saveBtn.classList.remove('disabled'); saveBtn.disabled = false;
    } else {
      saveBtn.classList.add('disabled'); saveBtn.disabled = true;
    }
  }

  // ---------- injury locations ----------
  async function populateLocationTable() {
    const result = await _UTIL.fetchData('getInjuryLocations', { token: $.session.Token });
    const list = result.getInjuryLocationsResult || [];
    const tableData = list.map(item => ({
      id: item.id,
      values: [item.description],
      endIcon: $.session.SetupDelete === true ? icons['delete'] : icons['empty'],
      endIconCallback: e => {
        e.stopPropagation();
        if ($.session.SetupDelete === true) handleLocationDelete(item);
      },
      onClick: e => {
        if (!e.target.classList.contains('endIcon')) showLocationPopup(item);
      },
    }));
    table.populate(locationTable, tableData);
    table.sortTableByHeader(locationTable);
  }

  function handleLocationDelete(item) {
    if (item.referenced === 'Y') {
      showMessagePopup('This injury location cannot be deleted, because it is associated to an existing injury.');
      return;
    }
    showDeleteConfirm('Are you sure you want to delete this injury location?', async () => {
      showProgressPopup('Deleting...');
      let res;
      try {
        const r = await _UTIL.fetchData('deleteInjuryLocation', { token: $.session.Token, id: item.id });
        res = r.deleteInjuryLocationResult;
      } catch { res = 'exception'; }
      hideProgressPopup();
      if (res === 'success') {
        successfulSave.show('Deleted');
        await populateLocationTable();
        setTimeout(() => successfulSave.hide(), 2000);
      } else if (res === 'referenced') {
        showMessagePopup('This injury location cannot be deleted, because it is associated to an existing injury.');
      } else {
        failSave.show('An error occured.');
        setTimeout(() => failSave.hide(), 2000);
      }
    });
  }

  function buildBodySvg(viewName) {
    const NS = 'http://www.w3.org/2000/svg';
    const svg = document.createElementNS(NS, 'svg');
    // viewBox 0 0 200 340 — pct values in BODY constant reference this coordinate space
    if (viewName === 'posterior') {
      svg.setAttribute('viewBox', '35 -150 2000 2000');
    } else {
      svg.setAttribute('viewBox', '-650 -150 2000 2000');
    }

    svg.classList.add('injuryBodySvg');

    function el(tag, attrs) {
      const e = document.createElementNS(NS, tag);
      const base = { fill: 'none', stroke: '#000000', 'stroke-width': '3', 'stroke-linecap': 'round', 'stroke-linejoin': 'round', 'stroke-miterlimit': '10' };
      Object.entries({ ...base, ...attrs }).forEach(([k, v]) => e.setAttribute(k, String(v)));
      svg.appendChild(e);
    }

    if (viewName === 'posterior') {
      el('path', { d: 'M1151.768,481.649c-15.051,114.163-0.51,104.205,4.04,181.878c1.69,28.838,21.406,89.641,17.888,127.603c0,0,6.357,34.022,5.142,105.169c-0.708,41.492-1.808,82.983-7.408,124.19c-1.323,9.732-4.851,19.043-4.162,29.192c7.888,116.13,0.476,54.468,12.949,107.909c15.144,64.887,16.842,103.862,3.28,163.503c-12.182,53.573-22.559,94.02-20.294,124.237c0.761,10.156,3.04,20.777,1.018,30.439c-5.948,28.418,31.747,123.535,4.503,126.218c-5.161,0.508-1.718,9.596-8.899,14.219c-0.792,0.51-3.719,2.504-3.985-1.222' });
      el('path', { d: 'M904.742,483.007c3.451,10.461,6.976,77.528,6.805,93.653c-0.152,14.251-4.156,27.966-5.625,42.057c-10.88,104.368-23.949,124.543-23.256,163.566c0.018,1.001-12.983,160.304,4.129,244.919c4.325,21.387,0.819,42.147,0.273,63.189c-0.288,11.089,0.145,22.333-1.595,33.211c-6.321,39.501-35.8,89.214-10.704,203.66c27.652,126.103,18.484,106.984,18.221,132.308c-0.094,9.09-1.499,18.21,1.011,27.115c0.888,3.149,0.52,6.14-0.242,8.82c-7.073,24.867-13.163,55.738-15.341,93.696c-0.472,8.216,2.609,11.844,10.745,13.408c3.022,0.581,1.741,2.208,1.989,3.553c0.8,4.332,2.475,8.153,6.129,10.849c2.632,1.942,3.181-0.411,4.068-2.03' });
      el('path', { d: 'M1029.612,820.971c1.591,7.624,0.486,15.675,3.419,23.064c10.535,26.538,0.078,65.63,22.751,129.058c31.291,87.538-9.891,116.802,37.244,194.482c10.64,17.534-1.02,31.361,0.337,93.157c0.264,12.043,18.212,83.315,25.292,121.45c4.14,22.297-7.885,43.672-11.228,80.085c-6.489,70.662-21.663,102.5-7.907,134.389c1.825,4.232-0.563,8.583,0.592,12.918c1.527,5.731,3.079,11.248,7.509,15.624c6.851,6.767,10.14,7.63,19.013,3.977c0.906-0.373,1.726-1.98,2.694-1.239c6.279,4.803,10.405,0.741,14.214-3.526c1.478-1.656,2.961-1.726,4.818-2.052c3.007-0.528,5.544-2.21,7.481-4.661' });
      el('path', { d: 'M1019.432,857.617c-7.763,130.113-16.565,80.577-29.958,170.325c-6.236,41.787,9.408,67.487-14.992,120.74c-3.518,7.678-6.988,15.583-12.105,22.432c-8.554,11.449,1.368,25.531,1.415,84.867c0.018,22.305-20.478,91.095-25.774,130.302c-3.617,26.783,8.759,37.03,13.401,92.305c4.279,50.96,19.563,85.723,5.962,118.629c-0.961,2.324-0.305,3.814-0.277,5.549c0.369,22.967-15.065,33.762-25.851,27.746c-1.696-0.946-2.616-2.396-4.851-0.672c-7.899,6.094-11.218-7.108-19.623-7.432c-3.03-0.116-4.165-3.01-6.109-4.711' });
      el('path', { d: 'M1277.995,850.831c4.443,5.908,2.049,5.14,12.905,45.466c0.757,2.812,0.676,6.218,5.431,5.516c18.863-2.785-11.706-61.841-6.022-64.331c6.503-2.85,20.876,48.011,22.411,49.165c2.191,1.647,4.893,3.884,8.017,1.493c2.694-2.061,4.078-4.545,2.754-8.138c-16.405-44.5-24.673-89.486-19.684-91.549c3.955-1.636,25.904,33.002,35.204,20.257c3.289-4.507,2.078-1.474-24.324-37.992c-16.67-23.056-43.883-7.136-51.853-44.709c-5.613-26.458-12.603-34.109-12.706-48.232c-0.382-52.672-13.513-101.383-21.142-109.808c-3.811-4.209-1.84-28.691-15.34-116.199c-1.131-7.332,2.722-14.37,3.266-21.698c1.617-21.787,1.96-43.455-1.87-65.177c-10.54-59.777-83.908-52.868-129.091-94.993c-9.156-8.536-15.297-41.951-0.864-67.949c6.308-11.363,13.263,2.789,23.17-20.296c4.526-10.546,4.771-20.729-4.698-29.119c-6.105-5.409,16.005-100.854-61.722-109.366c-65.677-7.192-93.62,35.908-86.977,101.882c0.295,2.924,1.07,6.108-1.87,8.879c-12.315,11.603-7.64,27.179,0.719,37.172c3.114,3.723,6.238,8.702,12.821,6.276c6.321-2.33,30.674,55.922-5.326,81.543c-50.207,35.733-112.379,31.092-120.281,92.104c-3.327,25.687-3.042,51.243,2.054,76.692c1.486,7.422-1.256,14.531-2.221,21.688c-4.202,31.159-8.36,62.309-10.637,93.681c-0.111,1.524-0.404,2.708-1.286,4.13c-16.051,25.892-22.51,83.318-21.935,113.954c0.187,9.952-4.098,11.675-16.757,58.385c-1.638,6.044-5.063,9.65-10.923,11.583c-32.276,10.644-34.372,15.808-60.504,52.127c-1.595,2.217-3.068,3.631-0.653,6.219c10.543,11.298,31.633-21.669,34.618-20.304c9.716,4.444-14.747,79.705-18.309,90.14c-2.195,6.431-1.695,9.955,2.772,10.738c4.774,0.838,7.538-2.321,8.777-6.661c14.27-49.994,24.531-48.996,20.857-38.749c-8.791,24.518-14.463,52.039-12.607,53.585c2.108,1.756,3.091,4.954,6.703,4.912c6.202-0.071,4.382-5.7,10.922-28.546c2.266-7.917,2.796-16.329,6.722-23.771' });
      el('path', { d: 'M1167.376,402.927c-2.074,21.524-14.009,22.105-13.985,64.471c0.041,71.102,19.385,84.11,17.297,123.509c-1.464,27.631,5.486,53.495,15.718,78.716c11.011,27.141,24.247,72.846,37.41,88.821c0.974,1.183,0.788,1.727,0.589,2.811c-5.245,28.542,17.21,57.719,18.799,73.986c1.305,13.355,3.332,26.633,4.218,40.025c0.784,11.843,8.814,6.649,8.879,4.07c0.344-13.576,1.831-27.115,1.335-40.719' });
      el('path', { d: 'M903.384,483.007c-2.904,21.342-5.194,42.759-9.998,63.834c-1.756,7.703-6.199,14.386-7.045,22.346c-5.086,47.856,17.117,24.782-43.41,173.719c-6.082,14.966-11.815,16.76-10.789,20.377c5.268,18.574-7.623,44.855-15.643,62.43c-3.177,6.963-7.178,49.33-7.358,51.593c-0.3,3.787-1.289,6.272-5.516,6.087c-6.189-0.272-1.541-1.998-4.751-35.275' });
      el('path', { d: 'M1158.554,334.384c5.695-3.637,16.522,3.314,18.189-4.778c1.552-7.536-28.184-14.231-49.363-5.3c-3.045,1.284-4.492,1.584-6.995-1.316c-5.06-5.862-21.272-13.941-22.97-3.546c-3.421,20.944-11.906,21.182-6.501,43.553c8.898,36.832-15.063,99.562,15.391,88.809c32.88-11.609,19.406-50.132,42.037-69.955c15.065-13.196,24.391-27.076,12.249-44.753c-11.342-16.513-15.584-8.218-55.644,7.478c-5.005,1.961-8.514,5.323-9.506,10.845' });
      el('path', { d: 'M961.069,356.779c-2.619-16.156-20.372-11.308-38.062-23.669c-12.872-8.994-28.943-4.895-32.455,26.39c-0.354,3.149,1.287,6.009,3.398,8.068c5.27,5.141,9.495,11.123,15.324,15.941c22.75,18.803,7.009,62.548,47.736,70.933c18.258,3.759,3.188-54.942,8.118-87.486c1.518-10.022,7.937-7.843-2.585-34.655c-1.416-3.609-2.623-7.427-2.918-11.485c-0.808-11.111-18.308-3.158-25.024,4.744' });
      el('path', { d: 'M798.873,839.973c-6.276,19.967-11.655,54.93-14.234,59.053c-2.205,3.526-10.469,3.749-9.777-4.106c1.064-12.087,3.211-23.982,4.934-35.956c0.709-4.929-0.567-10.083,1.432-14.919' });
      el('path', { d: 'M954.283,340.492c-26.324-22.016-48.018-22.859-69.202-15.553c-2.676,0.923-5.294,2.232-4.81,6.057c0.902,7.145,11.819,0.697,17.685,4.745' });
      el('path', { d: 'M889.133,404.284c3.543,23.649,12.816,14.802,14.93,77.365' });
      el('path', { d: 'M1028.933,788.396c-1.088,2.176-0.84,4.54-0.633,6.782c1.435,15.586-1.629,30.814-3.361,46.161c-0.571,5.06-3.833,9.195-4.149,14.243' });
      el('path', { d: 'M1156.518,1487.398c-2.703-18.815-30.143-40.433-42.079-12.895c-0.886,2.044-1.807,4.073-2.712,6.109' });
      el('path', { d: 'M1258.993,845.402c2.852,3.45,9.348,38.405,11.952,48.928c1.285,5.191,3.713,5.609,7.729,5.374c5.925-0.347,3.704-4.641,3.3-7.462c-1.521-10.64-2.215-21.419-4.722-31.894c-1.296-5.415,1.815-11.095-1.293-16.303' });
      el('path', { d: 'M944.782,1480.611c-2.976-5.119-8.493-26.246-27.813-14.91c-8.421,4.941-14.649,11.624-16.299,21.697' });
      el('path', { d: 'M946.139,1088.356c2.491,19.774,2.679,51.647,1.357,54.291' });
      el('path', { d: 'M1111.049,1087.677c-2.677,17.795-3.472,35.662-2.036,53.613' });
      el('path', { d: 'M1134.802,1167.078c-12.406,10.805-22.183,23.429-27.103,39.375c-0.268,0.867-0.431,1.408-1.4,1.344' });
      el('path', { d: 'M921.708,1168.436c13.726,10.616,22.632,24.604,28.503,40.719' });
      el('path', { d: 'M1035.041,854.224c-21.747-2.956-7.425,10.858-54.97,10.858' });
      el('path', { d: 'M1037.756,855.581c9.464,9.39,22.95,8.144,38.683,8.144' });
      el('path', { d: 'M1138.195,1423.605c0.153,9.953-1.773,19.907,0,29.86' });
      el('path', { d: 'M1050.65,735.462c-9.872,5.355-17.736,12.66-22.395,23.074' });
      el('path', { d: 'M918.315,1425.641c1.056,9.275,1.178,18.55,0,27.824' });
      el('path', { d: 'M924.422,1427.677c-0.448,9.184,0.678,18.21,2.715,27.146' });
      el('path', { d: 'M1005.859,736.819c10.153,4.846,23.116,14.747,21.717,25.788' });
      el('path', { d: 'M1132.766,1427.677c0.037,8.75-0.599,17.411-3.393,25.788' });
      el('path', { d: 'M1121.229,326.24c-6.334,4.298-12.668,8.596-19.002,12.894' });
    } else {
      el('path', { d: 'M464.981,519.653c-10.417,111.119-5.977,55.255-1.255,108.574c8.44,95.303,24.416,122.006,23.478,165.594c-0.022,1,13.034,124.024-2.551,237.528c-1.397,10.175-4.895,19.96-4.172,30.547c7.426,108.868,0.635,58.636,13.135,109.221c32.673,132.223-12.613,177.76-18.13,275.58c-0.511,9.064,3.054,36.524,2.262,39.307c-6.778,23.81,17.331,74.645,13.631,115.399c-0.688,7.574-2.604,9.708-10.137,11.428c-2.609,0.596-1.714,2.101-2.029,3.504c-2.283,10.16-10.066,14.383-19.024,16.818c-4.289,1.165-9.748,12.552-16.9,6.233c-1.654-1.461-2.28-0.003-3.444,0.66c-6.592,3.753-14.034,2.766-18.945-2.696c-11.53-12.822-5.614-22.873-9.522-33.23c-11.06-29.307,2.113-67.887,4.533-92.312c10.119-102.108,23.33-92.619,12.499-136.405c-6.01-24.295-9.662-49.15-16.471-73.244c-15.032-53.189,7.313-101.202-6.42-124.375c-19.304-32.573-27.557-67.598-22.928-105.749c4.426-36.473-17.184-97.458-21.22-112.004c-12.136-43.741-6.978-72.862-11.759-93.591' });
      el('path', { d: 'M223.384,519.653c2.768,9.998,2.012,20.382,3.309,30.55c5.764,45.188,3.259,43.06,1.335,56.98c-13.516,97.765-1.073,28.805-16.798,114.717c-30.929,168.98-4.175,306.82-4.316,363.741c-0.225,91.5-42.143,124.756-14.84,245.69c30.852,136.651,19.794,114.706,19.242,138.426c-0.221,9.488-1.613,19.21,1.368,28.448c1.376,4.266-0.824,7.373-1.605,10.89c-16.539,74.427-11.59,71.852-13.881,88.282c-2.513,18.022,12.219,11.087,12.641,18.961c0.728,13.601,16.984,15.186,23.743,21.019c9.686,8.36,9.302,0.104,15.666,3.262c8.028,3.983,15.693,1.455,20.928-6.656c9.096-14.094,2.799-18.427,7.404-30.553c13.628-35.886-10.363-87.507-11.411-149.266c-0.111-6.567-17.233-41.58-6.096-79.388c1.425-4.837,20.82-91.295,20.979-92.311c5.932-37.785-7.561-89.908-0.643-100.424c21.81-33.153,29.946-71.512,26.55-101.821c-7.395-65.988,30.614-115.556,29.69-194.758c-0.075-6.466,2.332-12.572,2.104-19.003' });
      el('path', { d: 'M296.678,244.124c-4.19,19.097,9.306,50.647-34.632,68.49c-44.234,17.963-95.22,12.274-101.556,64.551c-3.028,24.983-3.876,50.296,4.206,74.506c3.401,10.188-1.604,18.002-3.392,26.516c-8.632,41.095-13.299,99.112-13.299,99.112c-9.262,12.533-11.529,27.476-14.954,42.096c-15.107,64.479,2.252,46.208-17.617,107.906c-2.259,7.014-5.043,14.042-6.369,21.123c-1.434,7.656-6.046,12.898-23.429,17.626c-17.657,4.803-27.617,18.515-37.379,32.496c-10.631,15.225-15.121,17.451-12.809,20.351c11.528,14.457,30.031-20.744,35.853-18.762c9.279,3.161-13.432,76.207-18.984,90.715c-3.476,9.085,8.169,14.089,11.62,4.102c6.015-17.408,16.141-49.54,21.667-45.456c1.98,1.464,0.338,3.351-0.086,4.694c-4.692,14.876-12.52,39.591-12.861,50.25c-0.296,9.255,9.513,12.288,11.539,4.734c12.764-47.585,10.985-47.954,14.32-50.201' });
      el('path', { d: 'M391.688,242.767c-8.801,8.418-16.615,17.915-27.136,24.447c-11.446,7.107-33.796,5.505-45.476-3.414c-7.806-5.961-14.679-12.9-21.031-20.364c-1.976-2.322-2.437-5.118-2.816-8.123c-6.341-50.274-16.355-7.164-30.248-48.263c-2.839-8.399-0.444-16.697,6.042-22.865c3.023-2.875,2.766-5.847,2.513-8.959c-9.08-111.873,76.85-113.455,112.68-90.202c40.159,26.062,24.798,92.874,31.171,99.108c13.933,13.631,4.715,33.987-6.064,42.611c-3.016,2.413-10.583-3.609-14.835,12.284c-5.922,22.134-5.17,44.293-0.104,66.505c7.227,31.686,79.932,37.336,104.473,50.377c16.286,8.655,25.005,22.78,27.315,41.218c3.424,27.33,2.782,54.293-5.621,80.733c-0.382,1.203-0.844,2.496-0.492,3.4c10.48,26.918,17.112,97.257,17.485,104.544c0.341,6.654,2.371,12.429,5.344,18.404c12.61,25.337,19.883,83.901,18.028,107.836c-0.324,4.185,1.819,8.656,3.221,12.864c19.139,57.426,10.838,50.458,27.167,57.554c23.294,10.124,21.269,1.846,47.995,36.887c12.706,16.659,12.889,17.467,10.965,20.25c-13.179,19.056-50.349-62.77-32.587,13.594c14.075,60.513,22.996,63.993,13.624,66.569c-11.535,3.17-6.312-10.023-26.376-48.988c-0.91-1.767-2.005-2.403-3.479-1.906c-5.999,2.024,26.128,62.891,5.4,64.326c-3.545,0.245-4.067-2.888-4.71-5.366c-12.71-48.992-10.925-45.756-12.93-46.139' });
      el('path', { d: 'M466.339,519.653c3.395,12.122,7.193,51.694,11.568,65.139c1.638,5.034,0.103,9.959,0.039,14.941c-0.175,13.585,2.62,26.784,5.156,40.078c1.961,10.284,7.657,18.603,11.682,27.811c11.723,26.815,24.204,74.932,39.504,97.642c2.8,4.157,3.284,8.038,2.806,12.968c-3.258,33.605,16.561,31.952,22.252,96.347c1.638,18.531,2.096,18.964,6.074,19.059c2.173,0.052,3.937-0.807,3.988-2.771c0.345-13.352,2.1-26.653,1.442-40.038' });
      el('path', { d: 'M222.027,519.653c-4.329,23.028-6.229,46.46-11.922,69.295c-1.097,4.399,4.361,38.76-9.484,65.565c-18.155,35.15-34.202,100.583-48.491,114.205c-0.958,0.913-1.902,1.547-1.436,3.408c5.282,21.113-7.566,43.772-16.021,64.53c-3.656,8.976-2.915,18.923-4.225,28.43c-3.542,25.707-1.3,28.3-7.501,28.536c-6.581,0.25-2.506-2.967-5.431-36.007' });
      el('path', { d: 'M117.516,850.831c-13.86,41.119-7.616,63.897-22.4,59.737c-3.24-0.912-2.169-3.611-1.941-5.434c0-0.003,6.696-51.588,6.696-51.588' });
      el('path', { d: 'M573.564,858.975c12.336,40.372,6.915,54.306,18.307,52.168c4.114-0.772,4.173-3.574,3.546-7.4c-1.955-11.928-2.847-24.045-5.144-35.896c-0.763-3.934,2.769-8.143-1.1-11.587' });
      el('path', { d: 'M335.36,320.132c-21.875-14.489-62.757,13.778-103.154,6.786' });
      el('path', { d: 'M456.159,325.561c-25.026,11.858-71.267-17.589-102.475-6.108' });
      el('path', { d: 'M458.873,700.172c-27.126,16.192-53.589,82.987-81.437,89.581' });
      el('path', { d: 'M475.161,420.571c-0.575,15.076-12.358,18.926-12.929,35.967c-0.645,19.264,3.531,49.719,3.428,61.758' });
      el('path', { d: 'M231.528,700.851c31.098,23.832,48.744,77.841,79.401,88.902' });
      el('path', { d: 'M328.574,548.156c-25.691,13.08-79.345,80.337-92.295,65.15' });
      el('path', { d: 'M361.828,548.835c34.003,22.475,74.414,76.78,91.617,64.471' });
      el('path', { d: 'M450.73,459.933c-16.606,22.481-57.325,32.084-88.224,14.93' });
      el('path', { d: 'M238.993,459.933c7.006,17.314,51.743,34.832,86.866,14.93' });
      el('path', { d: 'M213.205,420.571c3.178,19.322,14.524,20.186,13.527,40.038c-0.91,18.111-3.967,57.324-4.026,57.687' });
      el('path', { d: 'M263.424,1100.572c-15.317-16.826-35.011-11.481-39.372,13.571c-0.177,1.018,0.795,2.656-1.347,2.716' });
      el('path', { d: 'M464.981,1116.859c-1.067-17.283-12.938-32.07-30.489-23.649c-3.576,1.716-7.609,3.313-9.551,7.361' });
      el('path', { d: 'M262.067,451.789c-9.497,3.599-8.26,16.653,1.357,15.605c12.288-1.339,12.584-16.126,2.715-15.605' });
      el('path', { d: 'M422.227,451.789c-13.977,2.505-4.206,18.024,5.407,15.522c4.308-1.121,6.439-3.653,4.949-8.787c-0.907-3.126-0.32-6.589-4.926-6.735' });
      el('path', { d: 'M275.64,1152.148c-3.294,16.504-11.649,23.479-27.148,23.189c-2.863-0.054-4.904-1.733-7.463-2.151' });
      el('path', { d: 'M364.542,227.158c-8.26-10.286-30.234-7.953-38.077-2.826c-3.379,2.209-2.685,2.799,0.005,4.948c16.072,12.838,35.451,2.206,38.072-1.443' });
      el('path', { d: 'M413.404,1154.184c6.203,24.735,27.204,22.935,33.932,19.002' });
      el('path', { d: 'M124.981,776.18c-6.588,16.63-19.34,23.469-36.647,23.074' });
      el('path', { d: 'M564.063,776.859c6.494,16.291,19.057,22.834,35.968,22.395' });
      el('path', { d: 'M372.007,837.258c-3.109,7.63-6.908,15.213-11.834,21.483c-7.181,9.138-26.022,11.056-33.682-3.814c-3.106-6.03-6.739-11.788-10.132-17.669' });
      el('path', { d: 'M358.434,295.701c-7.287,8.765-19.944,8.765-27.146,0' });
      el('path', { d: 'M328.574,151.829c-8.967-6.481-20.878-5.903-28.503,0' });
      el('path', { d: 'M387.616,151.15c-9.427-6.031-18.67-4.494-27.824,0.679' });
      el('path', { d: 'M362.506,172.188c9.646,1.778,34.898-2.039,21.016-6.031c-7.665-2.204-15.401-4.146-22.373,1.959' });
      el('path', { d: 'M327.217,168.116c-13.505-9.685-33.123,0.85-23.066,2.67c7.176,1.298,14.369,2.562,21.708,1.402' });
      el('path', { d: 'M363.863,203.406c-0.226,0-0.588-0.092-0.659,0.013c-3.592,5.278-9.003-2.038-12.96,1.977c-4.324,4.386-8.632,2.958-12.903-0.565c-3.889-3.207-9.481,5.034-12.838-2.782' });
      el('path', { d: 'M340.79,648.595c1.952,5.444,3.105,5.548,7.465,0.679' });
    }

    return svg;
  }

  function buildCheckbox(part, item, canEdit) {
    const wrap = document.createElement('label');
    wrap.classList.add('injuryBodyPart');
    if (part.col == 'ar_RightLable' || part.col == 'al_LeftLable' || part.col == 'pl_LeftLable' || part.col == 'pr_RightLable') {
      wrap.innerHTML = part.label;
      wrap.style.fontSize = '16px';
      wrap.style.fontWeight = '500';
    }
    else {
      const cb = document.createElement('input');
      cb.type = 'checkbox';
      cb.id = part.col;
      cb.checked = item ? item[part.col] === 'Y' : false;
      cb.addEventListener('change', toggleLocationSave);
      if (!canEdit) cb.disabled = true;
      wrap.appendChild(cb);
    }   
    return wrap;
  }

  function buildBodyView(viewName, sides, item, canEdit) {
    const section = document.createElement('div');
    section.classList.add('injuryBodyView');

    const heading = document.createElement('h4');
    heading.textContent = viewName === 'anterior' ? 'Anterior' : 'Posterior';
    section.appendChild(heading);

    // Wrapper maintains the SVG aspect ratio (viewBox 200×340 → padding-bottom 170%)
    const wrapper = document.createElement('div');
    wrapper.classList.add('injuryBodyWrapper');

    wrapper.appendChild(buildBodySvg(viewName));

    // Overlay every body-part checkbox at its pct position
    ['right', 'center', 'left'].forEach(side => {
      (sides[side] || []).forEach(part => {
        const lbl = buildCheckbox(part, item, canEdit);
        lbl.style.left = part.pct[0] + '%';
        lbl.style.top = part.pct[1] + '%';
        wrapper.appendChild(lbl);
      });
    });

    section.appendChild(wrapper);
    return section;
  }

  function showLocationPopup(item) {
    const isEdit = !!item;
    const canEdit = isEdit ? $.session.SetupUpdate : $.session.SetupInsert;
    const original = isEdit ? (item.description || '') : '';

    const input = new Input({ label: 'Injury Location', type: 'text', id: 'injuryLocationValue', maxlength: 100, value: original, required: true });

    const popup = POPUP.build({ classNames: 'injuryLocationPopup', hideX: true });

    // Scrollable body: input + body diagram
    const body = document.createElement('div');
    body.classList.add('injuryLocationBody');
    body.appendChild(input.rootElement);

    const diagram = document.createElement('div');
    diagram.classList.add('injuryBodyDiagram');
    diagram.appendChild(buildBodyView('anterior', BODY.anterior, item, canEdit));
    diagram.appendChild(buildBodyView('posterior', BODY.posterior, item, canEdit));
    body.appendChild(diagram);

    // Fixed footer: Save + Cancel buttons
    const btnWrap = document.createElement('div');
    btnWrap.classList.add('btnWrap', 'injuryLocationFooter');
    const saveBtn = button.build({
      id: 'injuryLocationSaveBtn', text: ' Save', icon: ['save'], style: 'secondary', type: 'contained',
      callback: async () => {
        saveBtn.classList.add('disabled'); saveBtn.disabled = true;
        const description = document.getElementById('injuryLocationValue').value.trim();
        const payload = {
          isEdit: isEdit ? 'Y' : 'N',
          id: isEdit ? String(item.id) : '',
          description,
        };
        allBodyColumns().forEach(col => {
          if (col != 'ar_RightLable' && col != 'al_LeftLable' && col != 'pl_LeftLable' && col != 'pr_RightLable') {
            const cb = document.getElementById(col);
            payload[col] = cb && cb.checked ? 'Y' : 'N';
          }
        });
        showProgressPopup('Saving...');
        let res;
        try {
          const r = await _UTIL.fetchData('saveInjuryLocation', { token: $.session.Token, location: payload });
          res = r ? r.saveInjuryLocationResult : 'exception';
        } catch { res = 'exception'; }
        hideProgressPopup();
        if (res === 'success') {
          POPUP.hide(popup);
          successfulSave.show('Saved');
          await populateLocationTable();
          setTimeout(() => successfulSave.hide(), 2000);
        } else if (res === 'duplicate') {
          showMessagePopup('This injury location already exists.', true);
          toggleLocationSave();
        } else {
          failSave.show(res === 'Error:606' || res === 'Error:607'
            ? 'Your session has expired. Please log in and try again.' : 'An error occured.');
          setTimeout(() => failSave.hide(), 2000);
          toggleLocationSave();
        }
      },
    });
    const cancelBtn = button.build({
      id: 'injuryLocationCancelBtn', text: 'Cancel', style: 'secondary', type: 'outlined',
      callback: () => POPUP.hide(popup),
    });
    btnWrap.appendChild(saveBtn);
    btnWrap.appendChild(cancelBtn);

    popup.appendChild(body);
    popup.appendChild(btnWrap);
    POPUP.show(popup);

    const inputEle = input.input || document.getElementById('injuryLocationValue');
    if (!canEdit) {
      inputEle.disabled = true;
      inputEle.classList.add('disabled');
    } else {
      inputEle.addEventListener('input', toggleLocationSave);
    }
    saveBtn.classList.add('disabled'); saveBtn.disabled = true;
  }

  function toggleLocationSave() {
    const inputEle = document.getElementById('injuryLocationValue');
    const saveBtn = document.getElementById('injuryLocationSaveBtn');
    if (!inputEle || !saveBtn) return;
    const value = inputEle.value.trim();
    // Save is enabled when the Location field is not null (and the user may edit).
    const permitted = !inputEle.disabled;
    if (value && permitted) {
      saveBtn.classList.remove('disabled'); saveBtn.disabled = false;
    } else {
      saveBtn.classList.add('disabled'); saveBtn.disabled = true;
    }
  }

  // ---------- view assembly ----------
  function buildSection(heading, columnHeading, tableId, addText, onAdd) {
    const frag = document.createDocumentFragment();
    const headingEle = document.createElement('h1');
    headingEle.classList.add('viewHeading');
    headingEle.textContent = heading;

    const tableEle = table.build({ tableId: tableId, columnHeadings: [columnHeading], endIcon: true });
    const headers = tableEle.querySelectorAll('.header div');
    headers[0].setAttribute('data-type', 'string');


    const btnWrap = document.createElement('div');
    btnWrap.classList.add('btnWrap');
    const addBtn = button.build({
      text: addText, icon: ['add'], style: 'secondary', type: 'outlined', callback: onAdd,
    });
    addBtn.style.padding = '6px';
    addBtn.style.marginTop = '15px';
    addBtn.style.width = '250px';
    if ($.session.SetupInsert) btnWrap.appendChild(addBtn);

    frag.appendChild(headingEle);
    frag.appendChild(tableEle);
    frag.appendChild(btnWrap);
    return { frag, tableEle };
  }

  async function getView() {
    const viewMarkup = document.createDocumentFragment();

    // Injury Causes
    const causes = buildSection(LOOKUPS.cause.heading, LOOKUPS.cause.column, 'injuryCausesTable',
      LOOKUPS.cause.addText, () => showLookupPopup(LOOKUPS.cause, null, causeTable));
    causeTable = causes.tableEle;
    viewMarkup.appendChild(causes.frag);

    // Injury Locations
    const locations = buildSection('Injury Locations', 'Location', 'injuryLocationsTable',
      'add new injury location', () => showLocationPopup(null));
    locationTable = locations.tableEle;
    viewMarkup.appendChild(locations.frag);

    // Injury Risks
    const risks = buildSection(LOOKUPS.risk.heading, LOOKUPS.risk.column, 'injuryRisksTable',
      LOOKUPS.risk.addText, () => showLookupPopup(LOOKUPS.risk, null, riskTable));
    riskTable = risks.tableEle;
    viewMarkup.appendChild(risks.frag);

    // Injury Types
    const types = buildSection(LOOKUPS.type.heading, LOOKUPS.type.column, 'injuryTypesTable',
      LOOKUPS.type.addText, () => showLookupPopup(LOOKUPS.type, null, typeTable));
    typeTable = types.tableEle;
    viewMarkup.appendChild(types.frag);

    await Promise.all([
      populateLookupTable(LOOKUPS.cause, causeTable),
      populateLocationTable(),
      populateLookupTable(LOOKUPS.risk, riskTable),
      populateLookupTable(LOOKUPS.type, typeTable),
    ]);

    return viewMarkup;
  }

  return {
    getView,
  };
})();
